import { Modal, Button, Row, Col } from 'react-bootstrap';
import React from 'react';
import styles from './customLinkShare.module.scss';
import { CustomModalIcon } from '../../shared/customModalIcon';
import { toast } from 'react-toastify';
import { CustomButton } from '../../shared/customButton';


export const CustomLinkShare = (props) => {
    function navigateURL() {
        window.open(props.link);
    }

    function copyURL() {
        navigator.clipboard.writeText(props.link)
        toast.success(<div>Link Copied!</div>, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.cancelIconclick}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <Row className={styles.modalRow}>
                        <Col className={styles.modalHeaderIconDiv}>
                            <Row>
                                <Col md={2}>
                                <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4.5" y="4" width="48" height="48" rx="24" fill="#D1FADF"/>
                                <rect x="4.5" y="4" width="48" height="48" rx="24" stroke="#ECFDF3" stroke-width="8"/>
                                <path d="M24 28L27 31L33 25M38.5 28C38.5 33.5228 34.0228 38 28.5 38C22.9772 38 18.5 33.5228 18.5 28C18.5 22.4772 22.9772 18 28.5 18C34.0228 18 38.5 22.4772 38.5 28Z" stroke="#039855" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                </Col>
                                <Col >
                                    <p className={styles.modalHeaderTopic}>{props.title}</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    

                    <div >
                        <p className={styles.modalHeaderTopic}>{props.topic}</p>
                        <p className={styles.modalHeaderSubTopic}>{props.message}&nbsp;
                        </p>
                        <p className={styles.modalHeaderSubTopic2}> {props.linkTitle} </p>
                        <Row className={styles.linkBox}>
                            <Col md={9}>  <p className={styles.sharebleLink}> {props.link}</p> </Col>
                            <Col md={1}>
                                <div className={styles.buttonDesing} >
                                    <div className={styles.copySharebleLinkCopyBtn} onClick={() => copyURL()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                            <g clip-path="url(#clip0_879_9755)">
                                                <path d="M4.5 4V2.6C4.5 2.03995 4.5 1.75992 4.60899 1.54601C4.70487 1.35785 4.85785 1.20487 5.04601 1.10899C5.25992 1 5.53995 1 6.1 1H9.9C10.4601 1 10.7401 1 10.954 1.10899C11.1422 1.20487 11.2951 1.35785 11.391 1.54601C11.5 1.75992 11.5 2.03995 11.5 2.6V6.4C11.5 6.96005 11.5 7.24008 11.391 7.45399C11.2951 7.64215 11.1422 7.79513 10.954 7.89101C10.7401 8 10.4601 8 9.9 8H8.5M3.1 11H6.9C7.46005 11 7.74008 11 7.95399 10.891C8.14215 10.7951 8.29513 10.6422 8.39101 10.454C8.5 10.2401 8.5 9.96005 8.5 9.4V5.6C8.5 5.03995 8.5 4.75992 8.39101 4.54601C8.29513 4.35785 8.14215 4.20487 7.95399 4.10899C7.74008 4 7.46005 4 6.9 4H3.1C2.53995 4 2.25992 4 2.04601 4.10899C1.85785 4.20487 1.70487 4.35785 1.60899 4.54601C1.5 4.75992 1.5 5.03995 1.5 5.6V9.4C1.5 9.96005 1.5 10.2401 1.60899 10.454C1.70487 10.6422 1.85785 10.7951 2.04601 10.891C2.25992 11 2.53995 11 3.1 11Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_879_9755">
                                                    <rect width="12" height="12" transform="translate(0.5)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                </div>
                            </Col>
                            <Col md={1}>
                                <div className={styles.buttonDesing}>
                                    <div className={styles.copySharebleLinkOpenBtn} onClick={() => navigateURL()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                            <path d="M11 4.5L11 1.5M11 1.5H7.99999M11 1.5L6.5 6M5.5 1.5H4.4C3.55992 1.5 3.13988 1.5 2.81901 1.66349C2.53677 1.8073 2.3073 2.03677 2.16349 2.31901C2 2.63988 2 3.05992 2 3.9V8.1C2 8.94008 2 9.36012 2.16349 9.68099C2.3073 9.96323 2.53677 10.1927 2.81901 10.3365C3.13988 10.5 3.55992 10.5 4.4 10.5H8.6C9.44008 10.5 9.86012 10.5 10.181 10.3365C10.4632 10.1927 10.6927 9.96323 10.8365 9.68099C11 9.36012 11 8.94008 11 8.1V7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className={styles.closeButton} >
                        <CustomButton
                             name={props.primaryBtnName}
                             buttonType={props.primaryBtnType}
                             disabled={props.isPrimaryBtnDisabled}
                             type='secondaryBtn'
                             id={props.primaryBtnId}
                             label={props.primaryBtnLabel}
                             backicon={props.primaryBtnBackSideIcon}
                             handleClick={props.onPrimaryBtnClick}
                            />
                        </div>
                        
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

